import {ArenaPictureDefaultBox} from './arena-picture.default.box';

export const ArenaPictureBox = ArenaPictureDefaultBox;